import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import AOS from 'aos'
import 'aos/dist/aos.css'
import App from 'App'
import Layer from 'components/atoms/Layer'
import Footer from 'routes/components/pages/GenericPage/Footer'
import MobileMenu from 'routes/components/pages/GenericPage/MobileMenu'
import Header from './Header'

const StickyLayer = styled(Layer)`
  position: sticky;
  top: 0;
`

export default class GenericPage extends Component {
  state = {
    isSliderVisible: false,
  }
  componentDidMount = () => {
    AOS.init({
      duration: 400,
      once: true,
    })
  }
  handleToggleMobileMenuClick = () => {
    this.setState(({ isSliderVisible }) => ({
      isSliderVisible: !isSliderVisible,
    }))
  }
  render() {
    const { children, overlayContent } = this.props
    const { isSliderVisible } = this.state
    return (
      <App>
        <StickyLayer zIndex={1}>
          <Header
            isMobileMenuOpen={isSliderVisible}
            onMobileMenuButtonClick={this.handleToggleMobileMenuClick}
          />
        </StickyLayer>
        {children}
        <Footer />
        {overlayContent}
        <Layer zIndex={2}>
          <MobileMenu
            isVisible={isSliderVisible}
            onClick={this.handleToggleMobileMenuClick}
          />
        </Layer>
      </App>
    )
  }
}

GenericPage.propTypes = {
  children: PropTypes.node.isRequired,
  overlayContent: PropTypes.node,
}
